export const isEmpty = (value: string | undefined): boolean => {
  return value === "" || value === undefined;
};
